<template>
  <!------Start Of Bread crumb------------>
  <section class="about-header section-bg-2" > <!---- :style="{ marginTop: activePromotion ? '0' : '64px' }" -->
    <div class="container">
      <h1> {{ $t('contactUs') }} </h1>
    </div>
  </section>
  <!-------End Of Bread crumb ----------->

  <!----start of contact Section--------->
  <section class="pt-80">
    <div data-anim-wrap class="container">
      <div class="row y-gap-50 justify-between contact-row ">
        <!----------Contact information section------------->
        <div class="col-lg-5 order-2 order-lg-1">
          <div class="contact-info">
            <h3 class="fw-700 capitalize"> {{ $t('contactInfo') }} </h3>
            <p class="mt-5"> {{ $t('readyToGetStarted') }} </p>

            <div class="y-gap-30 mt-35">
              <div class="d-flex items-center">
                <div class="d-flex justify-center items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5.00102 9.86077C6.91742 14.0346 10.3274 17.3531 14.5669 19.1521L15.2465 19.4549C16.8014 20.1477 18.6291 19.6214 19.5774 18.2079L20.4655 16.8842C20.7543 16.4538 20.6664 15.8741 20.263 15.5487L17.2511 13.1189C16.8088 12.762 16.1583 12.8452 15.8198 13.3018L14.8881 14.5591C12.4973 13.3797 10.5562 11.4387 9.37692 9.04792L10.6341 8.1162C11.0908 7.77778 11.1739 7.12726 10.817 6.68488L8.3872 3.67294C8.06185 3.26966 7.48235 3.18169 7.05198 3.47026L5.71914 4.36396C4.2968 5.31766 3.77342 7.16051 4.48215 8.71946L5.00024 9.85908L5.00102 9.86077Z"
                      fill="#94AD04" />
                  </svg>
                </div>
                <p class="ml-20"> +201027857863 </p>
              </div>

              <div class="d-flex items-center">
                <div class="d-flex justify-center items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M7.28934 4.90749C10.424 4.63501 13.5764 4.635 16.711 4.90749L18.2213 5.03877C19.2266 5.12617 20.0877 5.72584 20.5339 6.58362C20.5909 6.69335 20.5481 6.82621 20.443 6.89132L14.177 10.7703C12.8332 11.6022 11.1386 11.6196 9.77788 10.8156L3.47005 7.08821C3.36814 7.02799 3.32136 6.90403 3.36729 6.79493C3.77545 5.82536 4.69308 5.13318 5.77911 5.03878L7.28934 4.90749Z"
                      fill="#94AD04" />
                    <path
                      d="M3.3623 8.76673C3.20633 8.67457 3.00733 8.77375 2.98915 8.95399C2.73542 11.4696 2.79683 14.009 3.17338 16.5131C3.3719 17.8332 4.44931 18.8453 5.77925 18.9609L7.28948 19.0922C10.4241 19.3647 13.5765 19.3647 16.7111 19.0922L18.2214 18.9609C19.5513 18.8453 20.6287 17.8332 20.8272 16.5131C21.2148 13.9361 21.2685 11.3215 20.9885 8.73413C20.9688 8.55261 20.7665 8.45526 20.6112 8.55136L14.9667 12.0456C13.1485 13.1711 10.8559 13.1947 9.01492 12.1069L3.3623 8.76673Z"
                      fill="#94AD04" />
                  </svg>
                </div>
                <p class="ml-20">info@planning-force.com</p>
              </div>

              <div class="d-flex items-center">
                <div class="d-flex justify-center items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M18.1992 3.40003C16.2992 1.70003 13.7992 0.800022 11.1992 1.10003C7.19922 1.40003 3.89922 4.30003 3.19922 8.00003C2.69922 10.4 3.19922 12.8 4.69922 14.8L9.79922 21.9C10.1992 22.6 11.0992 23 11.9992 23C12.8992 23 13.7992 22.6 14.2992 21.8L19.3992 14.7C20.4992 13.2 20.9992 11.5 20.9992 9.70003C20.9992 7.30003 19.9992 5.00003 18.1992 3.40003Z"
                      fill="#94AD04" />
                    <path
                      d="M11.9996 13.1008C13.8773 13.1008 15.3996 11.5786 15.3996 9.70078C15.3996 7.82301 13.8773 6.30078 11.9996 6.30078C10.1218 6.30078 8.59961 7.82301 8.59961 9.70078C8.59961 11.5786 10.1218 13.1008 11.9996 13.1008Z"
                      fill="#D9D9D9" />
                  </svg>
                </div>
                <p class="ml-20">{{ $t('location') }}</p>
              </div>

              <section class="mt-50 contact-map">
                <!-- <iframe class="rounded-8"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3622.3153856762174!2d46.82072828002374!3d24.784651821198814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2fab919220c6a9%3A0x85087219a694a6c7!2z2YXYudmH2K8g2KfYqNiq2YPYp9ixINin2YTZhdi52LHZgdipINin2YTYudin2YTZiiDZhNmE2KrYr9ix2YrYqA!5e0!3m2!1sen!2seg!4v1733823885074!5m2!1sen!2seg"
                  width="404" height="265" style="border:0;" loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"></iframe> -->
              </section>
            </div>
          </div>
        </div>

        <div class="col-lg-7 order-1 order-lg-2">
          <!------Contact Form----------------->
          <div class="pt-15">
            <div class="get-in-touch d-flex flex-column y-gap-30 rounded-8">
              <div>
                <h3 class="fw-700 capitalize"> {{ $t('getInTouch') }}</h3>
                <p class="mt-25"> {{ $t('anyQuestions') }}</p>
              </div>
              <!--Start Of Contct Form-------------------->
              <form class="contact-form row y-gap-20" @submit.prevent="ContactForm">
                <div>
                  <label class="text-16 lh-1 fw-500 text-dark-1 mb-10 d-none"> {{ $t('name') }} </label>
                  <input type="text" name="title" placeholder="Name..." v-model="name">
                  <span class="errorMessage text-danger" v-if="v$.name.$error">
                    {{ v$.name.$errors[0].$message }}
                  </span>
                </div>
                <div>
                  <label class="text-16 lh-1 fw-500 text-dark-1 mb-10 d-none"> {{ $t('emailAddress') }}</label>
                  <input type="text" name="title" placeholder="Email..." v-model="email">
                  <span class="errorMessage text-danger" v-if="v$.email.$error">
                    {{ v$.email.$errors[0].$message }}
                  </span>
                </div>
                <div>
                  <label class="text-16 lh-1 fw-500 text-dark-1 mb-10 d-none"> {{ $t('message1') }} </label>
                  <textarea name="comment" placeholder="Message" rows="8" v-model="message"></textarea>
                  <span class="errorMessage text-danger" v-if="v$.message.$error">
                    {{ v$.message.$errors[0].$message }}
                  </span>
                </div>
                <div class="col-12">
                  <button type="submit" name="submit" id="submit" class="main-button pt-15 px-15 pb-15">
                    {{ $t('sendMessage') }}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!----End Of Contact Form------------------->
        </div>
      </div>
    </div>
  </section>
  <!------End of Contact Section---------->
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators';
export default {
  data() {
    return {
      name: '',
      email: '',
      message: ''
    }
  },
  setup() {
    return { v$: useVuelidate() }
  },
  validations() {
    return {
      name: { required },
      email: { required, email },
      message: { required },
    }
  },
  methods: {
    ContactForm() {
      this.v$.$validate();
      if (!this.v$.$error) {
        alert("success")
        this.resetForm()
      } else {
        alert('failed')
      }
    },
    resetForm(){
      this.email = '';
      this.name = '';
      this.message = ''
      this.v$.$reset();
    }
  }
}
</script>